import * as _ from 'underscore';
import { IListResource } from '../../ts/resources/Resource';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IUserNotification } from '@tableau/user-notifications-client-core';
import { GetUserNotificationsRequest } from '../redux/serverRequests/GetUserNotificationsRequest';
import { UpdateLastSeenUserNotificationRequest } from '../redux/serverRequests/UpdateLastSeenUserNotification';
import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import { CheckHasUnseenUserNotificationsRequest } from '../redux/serverRequests/CheckHasUnseenUserNotificationsRequest';
import { DeleteUserNotificationRequest } from '../redux/serverRequests/DeleteUserNotificationRequest';
import { UpdateUserNotificationReadStateRequest } from '../redux/serverRequests/UpdateUserNotificationReadStateRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';

class UserNotificationsResource implements IListResource<IUserNotification<any>> {

  private listFetcher: IListFetcher<IUserNotification<any>> = new WebClientListResourceFetcher(GetUserNotificationsRequest, ServerApiMapper.userNotifications);

  public all(): ResourceQuery<IUserNotification<any>> {
    return new ResourceQuery(this.listFetcher);
  }

  public getAllUserNotifications() {
    return this.all().getSlice(0, 100000).then(listResult => _.indexBy(listResult.items, 'id'));
  }

  public updateNotificationsStatus(ids: string[], isRead: boolean): Promise<{}> {
    const params = { ids: ids, readState: isRead };
    return this.sendRequest(new UpdateUserNotificationReadStateRequest(params));
  }

  public deleteNotification(id: string): Promise<{}> {
    return this.sendRequest(
      new DeleteUserNotificationRequest({ id: id }));
  }

  public checkHasUnseenUserNotifications(): Promise<boolean> {
    return this.sendRequest(
      new CheckHasUnseenUserNotificationsRequest()).then(result => result.hasUnseenNotifications);
  }

  public updateLastSeenUserNotification(id: string): Promise<{}> {
    return this.sendRequest(
      new UpdateLastSeenUserNotificationRequest(id));
  }

  private sendRequest<TParams, TResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
      return WebHttpClient.sendRequest(request);
  }
}

export const UserNotificationsResources = new UserNotificationsResource();
